import type { TabId } from '../components/CustomerHubCore'

export const AREA_SLUGS = {
  overview: 'overview',
  orders: 'orders',
  sizePassport: 'size-passport',
  wardrobe: 'wardrobe',
  settings: 'settings',
} as const satisfies Record<TabId, string>

const TAB_BY_SLUG = new Map<string, TabId>(
  Object.entries(AREA_SLUGS).map(([tab, slug]) => [slug, tab as TabId]),
)

export function parseAreaPath(
  area?: string,
  orderId?: string,
): { tab: TabId | undefined; orderId: string | null } | null {
  if (!area) return orderId ? null : { tab: undefined, orderId: null }

  const tab = TAB_BY_SLUG.get(area)
  if (!tab) return null
  if (orderId && tab !== 'orders') return null

  return { tab, orderId: orderId ?? null }
}

export function buildAreaPath(tab: TabId, orderId?: string | null): string {
  const slug = AREA_SLUGS[tab]
  return tab === 'orders' && orderId
    ? `/${slug}/${encodeURIComponent(orderId)}`
    : `/${slug}`
}

export function tabFromLegacyScreen(screen: string | null): TabId | undefined {
  const normalized = screen?.replace(/['"]/g, '').trim().toLowerCase() ?? ''

  if (normalized === 'orders') return 'orders'
  if (normalized === 'overview') return 'overview'
  if (['sizepassport', 'size-passport', 'size_passport'].includes(normalized)) {
    return 'sizePassport'
  }
  if (normalized === 'settings') return 'settings'
  if (normalized === 'wardrobe') return 'wardrobe'

  return undefined
}

export function parseLegacyScreenParams(
  params: URLSearchParams,
): { tab: TabId; orderId: string | null } | null {
  const tab = tabFromLegacyScreen(params.get('screen'))
  if (!tab) return null

  const orderId = tab === 'orders' ? params.get('orderId')?.trim() : undefined
  return { tab, orderId: orderId || null }
}
